<script lang="ts">
    import { putDBEntry } from "../../api"
    import CollapsibleWrapper from "../components/CollapsibleWrapper.svelte"
    import TaskForm from "../components/taskForm/TaskForm.svelte"
    import { onChange } from "../components/formComponents/helper"
    import Input from "../components/formComponents/Input.svelte"
    import Map from "../components/formComponents/Map.svelte"
    import { isMobile, newNotification, rerenderSteps } from "../store"
    export let task: Task

    async function updateTask(taskP: Partial<Task>, valueChanged: boolean) {
        if (!valueChanged) return
        await putDBEntry("task", { ...taskP, id: task.id })
            .then(() => {
                newNotification({
                    html: "Auftrag aktualisiert",
                    class: "success",
                })
            })
            .catch(() =>
                newNotification({
                    html: "Fehler beim Aktualisieren des Auftrags",
                    class: "error",
                })
            )
    }
    $: if (!task.generalDetails)
        task.generalDetails = {
            description: task.generalDetails?.description ?? "",
            shortDescription: task.generalDetails?.shortDescription ?? "",
        } as Task["generalDetails"]
    $: if (!task.generalDetails.location) task.generalDetails.location = {} as Task["generalDetails"]["location"]
    $: if (task && typeof task.meta.contactPerson !== "object") {
        task.meta.contactPerson = {
            id: undefined,
        } as Task["meta"]["contactPerson"]
    }

    function handleTaskFormBlur(event: CustomEvent<{ patch: Partial<BaseTask>; valueChanged?: boolean }>) {
        const { patch, valueChanged } = event.detail
        updateTask(patch as Partial<Task>, valueChanged ?? false)
    }

    function handleTaskFormChange(event: CustomEvent<{ patch: Partial<BaseTask> }>) {
        updateTask(event.detail.patch as Partial<Task>, true)
    }

    function handleTaskTypeChange(event: CustomEvent<{ taskType: Task["taskType"] }>) {
        task.taskType = event.detail.taskType
        updateTask({ taskType: event.detail.taskType }, true).then(() => ($rerenderSteps += 1))
    }
</script>

<form>
    <CollapsibleWrapper
        icon="solar_checklist-outline.svg"
        title="Generelle Einsatzdaten"
        initiallyCollapsed="{$isMobile}"
    >
        <div class="row">
            <div class="col">
                <TaskForm
                    bind:task="{task}"
                    style="padding: 0px !important; gap: 0.6rem !important;"
                    on:blur="{handleTaskFormBlur}"
                    on:change="{handleTaskFormChange}"
                    on:taskTypeChange="{handleTaskTypeChange}"
                />
            </div>
            <div class="col">
                {#if task.generalDetails.location}
                    <Input
                        placeholder="Ortsnamen überschreiben"
                        id="nameOverride"
                        onChange="{onChange}"
                        bind:value="{task.generalDetails.location.overriddenName}"
                        onBlur="{(_, valueChanged) =>
                            updateTask({ generalDetails: task.generalDetails }, valueChanged)}"
                    />
                {/if}
                <Map
                    lat="{task?.generalDetails?.location?.latitude}"
                    long="{task?.generalDetails?.location?.langitude}"
                    name="{task?.generalDetails?.location?.name}"
                    onSelectLocation="{(lat, lang, place_name) => {
                        //@ts-ignore
                        task.generalDetails.location = {
                            latitude: lat,
                            langitude: lang,
                            name: place_name,
                        }
                        //@ts-ignore
                        updateTask({ generalDetails: task.generalDetails }, true)
                    }}"
                />
            </div>
        </div>
    </CollapsibleWrapper>
</form>

<style lang="less">
    form {
        width: 100%;
    }
</style>
